<template>
  <div
    v-if="items"
    class="row"
  >
    <div
      v-for="item in items"
      :key="item.id"
      class="col-12 col-md-6"
      :class="{'col-xl-4' : rowOfThree, 'col-lg-12': !rowOfThree, 'col-xl-6': !rowOfThree && items.length > 1 }"
    >
      <router-link
        v-if="useRouterLinks"
        :to="item.href"
        class="card-link"
      >
        <product-list-item
          :item="item"
          :show-creator="showCreator"
          :show-link="!!afterCreateTemplate"
          :do-create-product-link="doCreateProductLink"
          :do-select-product-link="doSelectProductLink"
          :read-only="readOnly"
        />
      </router-link>

      <div
        v-else
        type="button"
        class="card-link"
        @click="viewProduct(item)"
      >
        <product-list-item
          :item="item"
          :show-creator="showCreator"
          :show-link="!!afterCreateTemplate"
          :do-create-product-link="doCreateProductLink"
          :do-select-product-link="doSelectProductLink"
          :read-only="readOnly"
        />
      </div>
    </div>

    <create-prospect-template-modal
      v-if="afterCreateTemplate"
      ref="createProspectTemplateModal"
      :after-create="afterCreateTemplate"
    />
    <select-prospect-template-modal
      ref="selectProspectTemplateModal"
    />
  </div>
</template>

<script>
import ProductListItem from '@/components/tables/ProductListItem.vue';
import CreateProspectTemplateModal from '@/components/modals/CreateProspectTemplateModal.vue';
import SelectProspectTemplateModal from '@/components/modals/SelectProspectTemplateModal.vue';

export default {
  name: 'ProductTable',
  components: {
    ProductListItem,
    CreateProspectTemplateModal,
    SelectProspectTemplateModal,
  },
  props: {
    items: {
      type: Array,
    },
    viewProduct: {
      type: Function,
    },
    rowOfThree: {
      type: Boolean,
      default() {
        return false;
      },
    },
    readOnly: {
      type: Boolean,
    },
    showCreator: {
      type: Boolean,
    },
    useRouterLinks: {
      type: Boolean,
      default() {
        return false;
      },
    },
    afterCreateTemplate: {
      type: Function,
    },
  },
  methods: {
    doCreateProductLink(product) {
      this.$refs.createProspectTemplateModal.show(product);
    },
    doSelectProductLink(product) {
      this.$refs.selectProspectTemplateModal.show(product);
    },
  },
};
</script>

<style lang="scss" scoped>
.card-link {
  width: 100%;
}
</style>
